import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as signalR from '@microsoft/signalr';

import { environment } from '../../../../../../assets/environment/environment';
import { Logger } from '../../../../core/utilities/logging/logger';
import { AuthenticationService } from '../../../../user-management/auth-management/authentication/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class SignalRConnectionManager {
    private connectionStatusSubject = new BehaviorSubject<boolean>(false);
    public connection: signalR.HubConnection | null = null;

    public connectionStatus$ = this.connectionStatusSubject.asObservable();

    constructor(private authenticationService: AuthenticationService) { }

    public connectToHub(collectionUrl?: string): Observable<void> {
        if (this.connection) {
            this.disconnectFromHub();
        }

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(collectionUrl ? `${environment.hubUrl}/${collectionUrl}` : environment.hubUrl, {
                skipNegotiation: true,
                accessTokenFactory: () => this.getToken(),
                transport: signalR.HttpTransportType.WebSockets
            })
            .withAutomaticReconnect([0, 2000, 10000])
            // .configureLogging(signalR.LogLevel.Information)
            .build();

        return new Observable(observer => {
            const startConnection = () => {
                this.connection
                    ?.start()
                    .then(() => {
                        Logger.info(`'Signal R Hub succesfully connected`);
                        this.connectionStatusSubject.next(true);
                        observer.next();
                        observer.complete();
                    })
                    .catch(err => {
                        Logger.warn('Connection error:', err);
                        this.connectionStatusSubject.next(false);
                        setTimeout(startConnection, 5000);
                        observer.error(err);
                    });
            };

            startConnection();
        });
    }

    public disconnectFromHub(): void {
        if (this.connection) {
            this.connection.stop().catch(err => Logger.warn('Error disconnecting:', err));
            this.connection = null;
            this.connectionStatusSubject.next(false);
        }
    }

    isConnected(): boolean {
        return this.connectionStatusSubject.getValue();
    }

    getToken(): string {
        let token = this.authenticationService.ensureAuthenticated();
        return token?.accessToken ?? 'NO_TOKEN';
    }
}
